module.exports = __webpack_public_path__ + "img/alphaleaf_logo_brandmark_color.6d8f7d63.svg";